// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: inherit;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.logo__image {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-pill);
  object-fit: cover;
  box-shadow: var(--shadow-sm);
}

.logo__text {
  font-size: 1.05rem;
}

.logo--sm .logo__image {
  width: 32px;
  height: 32px;
}
.logo--sm .logo__text {
  font-size: 0.95rem;
}

.logo--lg .logo__image {
  width: 88px;
  height: 88px;
}
.logo--lg .logo__text {
  font-size: 1.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: inherit;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.logo__image {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-pill);\n  object-fit: cover;\n  box-shadow: var(--shadow-sm);\n}\n\n.logo__text {\n  font-size: 1.05rem;\n}\n\n.logo--sm .logo__image {\n  width: 32px;\n  height: 32px;\n}\n.logo--sm .logo__text {\n  font-size: 0.95rem;\n}\n\n.logo--lg .logo__image {\n  width: 88px;\n  height: 88px;\n}\n.logo--lg .logo__text {\n  font-size: 1.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
